module.exports = __webpack_public_path__ + "img/La-base-Beyrouth-Max-Quality.a07cc71b.jpg";